'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _effects = require('redux-saga/effects');

var _apiHelper = require('api/api-helper');

var _selectors = require('selectors');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _roomingListsDataActions = require('actions/roomingListsDataActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchRoomingListsData);

// Saga to fetch rooming list after departure services data is received
function fetchRoomingListsData() {
    var authToken, locale, depServicesById, depService, productId, roomingListsByProductId, result, roomMates;
    return _regenerator2.default.wrap(function fetchRoomingListsData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (!true) {
                        _context.next = 35;
                        break;
                    }

                    _context.next = 3;
                    return (0, _effects.take)(_roomingListsDataActions.ROOMING_LISTS_DATA_REQUESTED);

                case 3:
                    _context.next = 5;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 5:
                    authToken = _context.sent;
                    _context.next = 8;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 8:
                    locale = _context.sent;
                    _context.next = 11;
                    return (0, _effects.select)(_selectors.getDepartureServicesById);

                case 11:
                    depServicesById = _context.sent;

                    // Find the first departure service with a product id
                    depService = (0, _values2.default)(depServicesById).find(function (s) {
                        return s && s.product && s.product.id;
                    });
                    productId = depService && depService.product && depService.product.id;
                    _context.next = 16;
                    return (0, _effects.select)(function (state) {
                        return state.roomingListsByProductId || {};
                    });

                case 16:
                    roomingListsByProductId = _context.sent;

                    if (productId) {
                        _context.next = 21;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _roomingListsDataActions.roomingListsDataRequestFailed)('Missing product id'));

                case 20:
                    return _context.abrupt('continue', 0);

                case 21:
                    if (roomingListsByProductId[productId]) {
                        _context.next = 33;
                        break;
                    }

                    _context.next = 24;
                    return (0, _effects.call)(_apiHelper.getRoomingListData, productId, authToken, locale);

                case 24:
                    result = _context.sent;

                    if (!(result && result.error)) {
                        _context.next = 30;
                        break;
                    }

                    _context.next = 28;
                    return (0, _effects.put)((0, _roomingListsDataActions.roomingListsDataRequestFailed)(result.error._error));

                case 28:
                    _context.next = 33;
                    break;

                case 30:
                    roomMates = _lodash2.default.get(result, 'roomingListData.room_mates', []);
                    _context.next = 33;
                    return (0, _effects.put)((0, _roomingListsDataActions.roomingListsDataReceived)(roomMates));

                case 33:
                    _context.next = 0;
                    break;

                case 35:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchRoomingListsData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchRoomingListsData.js
// module id = 1417
// module chunks = 0